export const ClipboardIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33337 8.63379H10"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 11.2998H8.25337"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66671 4.49967H9.33337C10.6667 4.49967 10.6667 3.83301 10.6667 3.16634C10.6667 1.83301 10 1.83301 9.33337 1.83301H6.66671C6.00004 1.83301 5.33337 1.83301 5.33337 3.16634C5.33337 4.49967 6.00004 4.49967 6.66671 4.49967Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 3.17969C12.8867 3.29969 14 4.11969 14 7.16635V11.1664C14 13.833 13.3333 15.1664 10 15.1664H6C2.66667 15.1664 2 13.833 2 11.1664V7.16635C2 4.12635 3.11333 3.29969 5.33333 3.17969"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
